import React, { useState } from "react";
import { navigationLinks } from "../mock";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

const Navigation = ({ activeSection }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-[34px] left-0 right-0 z-50 bg-[#EFE7D5]/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3.5">
        <div className="flex items-center justify-between gap-6">
          {/* Logo + Wordmark */}
          <button
            onClick={() => scrollToSection("home")}
            className="flex items-center gap-3 group"
            data-testid="nav-logo"
          >
            <Logo size={34} variant="dark" />
            <div className="flex flex-col items-start leading-tight">
              <span className="text-[13px] sm:text-sm font-medium tracking-tight text-gray-900">
                Keimyung AI Research Center
              </span>
              <span className="hidden sm:inline text-[9px] font-mono uppercase tracking-[0.3em] text-gray-400">
                The Center for Artificial Intelligence
              </span>
            </div>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center">
            {navigationLinks
              .filter((link) => link.id !== "contact")
              .map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  data-testid={`nav-link-${link.id}`}
                  className={`relative px-3.5 py-1.5 text-[13px] tracking-tight transition-colors ${
                    activeSection === link.id
                      ? "text-gray-900"
                      : "text-gray-500 hover:text-gray-900"
                  }`}
                >
                  {link.label}
                  {activeSection === link.id && (
                    <span className="absolute left-3.5 right-3.5 -bottom-[14px] h-px bg-gray-900" />
                  )}
                </button>
              ))}

            <span className="mx-4 h-4 w-px bg-gray-300" />

            <button
              onClick={() => scrollToSection("contact")}
              data-testid="nav-contact-cta"
              className="group inline-flex items-center gap-1.5 text-[13px] font-medium tracking-tight text-gray-900 hover:text-[#00BCD4] transition-colors"
            >
              Contact
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-[#00BCD4] transition-colors"
            aria-label="Open menu"
          >
            {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-3 space-y-1">
            {navigationLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`flex items-center justify-between w-full text-left px-3 py-2.5 text-sm tracking-tight transition-colors ${
                  activeSection === link.id
                    ? "text-gray-900 font-medium"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                <span>{link.label}</span>
                <span className="text-[10px] font-mono text-gray-300">
                  /{String(navigationLinks.indexOf(link) + 1).padStart(2, "0")}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
